
import Vue from "vue";
import { Auth } from "aws-amplify";
import TextField from "@/components/molecules/TextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";

interface Data {
  username: string;
  message: string;
  submitting: boolean;
}

interface Methods {
  submit(): Promise<void>;
}

interface Computed {
  from: string | undefined;
}

export default Vue.extend<Data, Methods, Computed>({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
  components: { TextField, ButtonDefault },
  data() {
    return {
      username: "",
      message: "",
      submitting: false,
    };
  },
  computed: {
    from() {
      return this.$route.query.from;
    },
  },
  created() {
    if (this.from === "nolanovel") {
      document.title = this.$t('resetPasswordPage.pageTitle.nolaNovel') as string;
    } else if (this.from === "default") {
      document.title = this.$t('resetPasswordPage.pageTitle.default') as string;
    }
  },
  methods: {
    async submit() {
      const { username } = this;

      try {
        this.submitting = true;

        if (this.from === "nolanovel") {
          // Nolaノベルのユーザーの場合はclientMetadataに「serviceName: Nolaノベル」を追加
          // そうすることで、本人認証のための確認コード送信メールにて、「Nolaノベル」から送信されたことになる
          await Auth.forgotPassword(username, { serviceName: "Nolaノベル" });
        } else if (this.from === "default") {
          await Auth.forgotPassword(username, { serviceName: "Nola関連サービス" });
        } else {
          await Auth.forgotPassword(username);
        }

        // クエリパラメータを動的に構築する
        const query = this.from ? { from: this.from } : {};

        // ルートを遷移する
        this.$router.push({
          name: "resetPasswordSubmit",
          params: { username },
          query,
        });
      } catch (err) {
        const error = err as any;
        this.submitting = false;
        console.error(error);
        if (error.code === "UserNotFoundException") {
          this.message = this.$t('resetPasswordPage.validation.userNotFound') as string;
        } else if (error.code === "LimitExceededException") {
          this.message = this.$t('resetPasswordPage.validation.limitExceeded') as string;
        } else {
          this.message = this.$t('resetPasswordPage.validation.genericError') as string;
        }
      }
    },
  },
});
